import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { get } from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import { API_HOST } from '../../consts';
import { BaseForm } from '../../base';
import DetectorPlagio from './DetectorPlagio';
import VerificacaoAutomatica from './VerificacaoAutomatica';
import {
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  UncontrolledTooltip
} from 'reactstrap';
import InfoBox from '../../components/InfoBox';
import InfoBoxItem from '../../components/InfoBoxItem';
import Loading from '../../components/Loading';
class Etapa1 extends BaseForm {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.id = get(props, 'match.params.id');
  }

  state = {
    tipo: [],
    save: 0,
    metadata: {},
    fetchingData: false,
    status_item: [],
    revisoes: [],
    isOpen: false,
    fetchingRevisao: true
  };

  componentDidMount() {
    this.fetchRevisao();
  }

  mapRespostas(data) {
    const respostas = get(data, 'respostas') || [];
    const mapped = {};

    respostas.forEach((r) => {
      mapped[r.secao] = mapped[r.secao] || {};
      mapped[r.secao][r.pergunta] = r.valor;
    });

    return mapped;
  }

  fetchRevisoes = (item_id) => {
    return axios
      .get(`${API_HOST}/revisoes/revisao/summary`, {
        params: {
          item: item_id,
          ordering: '-finalizado_em'
        }
      })
      .then((response) => {
        this.setState({
          revisoes: response.data.results.filter(
            (d) => d.criado_por !== null && d.comentario !== null
          ),
          fetchingRevisao: false
        });
      });
  };

  fetchRevisao() {
    axios.get(`${API_HOST}/revisoes/revisao/${this.id}`).then((response) => {
      const { item, questionario, tipo, permissions, ...data } = response.data;
      const hasUpdatePermission = get(permissions, 'update');
      if (hasUpdatePermission) {
        const respostas = this.mapRespostas(data);
        this.setState({
          tipo,
          respostas,
          item_id: item,
          revisao: response.data
        });
        this.fetchRevisoes(item);
        this.fetchQuestionario(questionario);
      } else {
        const { history } = this.props;
        history.push('/itens');
      }
    });
  }

  fetchQuestionario(questionario) {
    axios
      .get(`${API_HOST}/questionarios/questionario/${questionario}`)
      .then((response) => {
        this.setState({
          questionario: response.data
        });
      });
  }

  onSubmit() {
    const { history } = this.props;
    history.push('2');
  }

  onRespostaChange(secao, pergunta, valor) {
    this.setState({ loading: true });

    axios
      .post(`${API_HOST}/revisoes/revisao/${this.id}/resposta`, {
        secao,
        pergunta,
        valor
      })
      .then(() => {
        const { respostas } = this.state;
        respostas[secao] = respostas[secao] || {};
        respostas[secao][pergunta] = valor;
        this.setState({ respostas, loading: false });
      });
  }

  renderQuestionario() {
    const { questionario, respostas } = this.state;
    const secoes = get(questionario, 'secoes', []);

    return (
      <div className="card card-bg questionario">
        <div className="card-header pb-0">
          <h1>{get(questionario, 'descricao')}</h1>
          <div style={{ textAlign: 'justify', marginTop: '0.5rem' }}>
            <span style={{ color: '#000' }}>
              Esse questionário tem o objetivo de direcionar sua revisão. Caso
              responda <strong>NÃO</strong> para um ou mais quesitos: selecionar{' '}
              <strong>COM PENDÊNCIAS</strong> na descrição do item e descrever
              no comentário a adequação a ser realizada. Não se esqueça de
              marcar a caixa Notificar elaborador por e-mail. Em seguida clicar
              em <strong>FINALIZAR</strong>. Caso responda <strong>SIM</strong>{' '}
              para todos os quesitos: selecionar <strong>APROVADO</strong> na
              descrição do item e clicar em Finalizar. Caso não se sinta apto a
              avaliar algum quesito, clique em Não Avaliado e selecionar{' '}
              <strong>APROVADO</strong> na descrição do item e clicar em
              Finalizar.
            </span>
          </div>
        </div>

        <div className="card-body">
          {secoes.map((s) => (
            <React.Fragment key={s.id}>
              <h5>{s.descricao}</h5>
              <table className="table table-bordered">
                <tbody>
                  {s.perguntas.map((p) => (
                    <tr key={p.id}>
                      <td>
                        <div className="row pergunta">
                          <div className="col-md-9 col-sm-5 col-xs-12">
                            <p>{p.descricao}</p>
                          </div>
                          <div className="col-md-3 col-sm-7 col-xs-12">
                            <input
                              type="radio"
                              name={`s${s.id}p${p.id}`}
                              id={`s${s.id}p${p.id}_1`}
                              onChange={() =>
                                this.onRespostaChange(s.id, p.id, '1')
                              }
                              value="1"
                              checked={
                                get(respostas, `${s.id}.${p.id}`) === '1'
                              }
                            />
                            <label
                              htmlFor={`s${s.id}p${p.id}_1`}
                              className="ml-1 mr-3"
                            >
                              Sim
                            </label>
                            <input
                              type="radio"
                              name={`s${s.id}p${p.id}`}
                              id={`s${s.id}p${p.id}_0`}
                              onChange={() =>
                                this.onRespostaChange(s.id, p.id, '0')
                              }
                              value="0"
                              checked={
                                get(respostas, `${s.id}.${p.id}`) === '0'
                              }
                            />
                            <label
                              htmlFor={`s${s.id}p${p.id}_0`}
                              className="ml-1"
                            >
                              Não
                            </label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  render() {
    const {
      item_id,
      loading,
      tipo,
      revisao,
      isOpen,
      revisoes,
      fetchingRevisao
    } = this.state;
    const { canViewPlagiusDetector, canDetectPlagius } = this.props;

    return (
      <div style={{ cursor: loading ? 'wait' : 'auto' }}>
        <h1
          className="mb-3"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <div>
            Revisão {get(tipo, 'descricao')} -{' '}
            <Link to={`/itens?id=${item_id}`}>Item {item_id}</Link>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            Total de revisões: {get(revisao, 'total_revisao_andamento', '')}
            {get(revisao, 'total_revisao_andamento', '') > 1 && (
              <>
                <UncontrolledTooltip
                  key={2}
                  delay={0}
                  placement="top"
                  target="ver-revisao"
                >
                  Ver comentários de revisões passadas
                </UncontrolledTooltip>
                <button
                  id="ver-revisao"
                  className="btn btn-white ml-2"
                  onClick={() => this.setState({ isOpen: true })}
                >
                  <i className="fas fa-eye" />
                </button>
              </>
            )}
          </div>
        </h1>
        <div className="row">
          <div className="col-md-12">
            {item_id && <VerificacaoAutomatica item={item_id} />}
          </div>
          {canViewPlagiusDetector && (
            <div className="col-md-12">
              {item_id && (
                <DetectorPlagio
                  item={item_id}
                  canDetectPlagius={canDetectPlagius}
                />
              )}
            </div>
          )}
          <div className="col-md-12">
            {this.renderQuestionario()}
            <button
              className="btn primary-button mt-2 mb-2 pull-right"
              type="button"
              onClick={this.onSubmit}
            >
              <i className="fas fa-chevron-right" />
            </button>
          </div>
        </div>
        <Modal size="lg" isOpen={isOpen}>
          <ModalHeader>Comentários de revisões Passadas</ModalHeader>
          <ModalBody style={{ minHeight: '200px', background: '#fff' }}>
            {fetchingRevisao && <Loading />}
            {!fetchingRevisao && (
              <div>
                {revisoes.map((data) => (
                  <>
                    <InfoBox>
                      <div className="row">
                        <InfoBoxItem
                          label="Item definido como"
                          value={get(data, 'status_item.descricao', 'Não definido')}
                        />
                      </div>
                    </InfoBox>
                    <InfoBox text="Comentários">
                      {get(data, 'comentario') !== '' ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: get(data, 'comentario')
                          }}
                        />
                      ) : (
                        <span
                          className="mb-0 info-box-item"
                          style={{ fontSize: '14px', marginTop: '-6px' }}
                        >
                          Não há comentários
                        </span>
                      )}
                    </InfoBox>
                    <hr />
                  </>
                ))}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <button
              className="btn danger-button mr-3"
              type="button"
              onClick={() => this.setState({ isOpen: false })}
            >
              Fechar
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

Etapa1.propTypes = {
  canViewPlagiusDetector: PropTypes.bool,
  canDetectPlagius: PropTypes.bool
};

Etapa1.defaultProps = {
  canViewPlagiusDetector: false,
  canDetectPlagius: false
};

export default withRouter(Etapa1);
